import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { AppShell } from './layout/app-shell'
import { Aidat } from './routes/aidat'
import { Ayarlar } from './routes/ayarlar'
import { AyarlarAbonelik } from './routes/ayarlar-abonelik'
import { AyarlarAlanAdlari } from './routes/ayarlar-alan-adlari'
import { AyarlarDernek } from './routes/ayarlar-dernek'
import { AyarlarMenu } from './routes/ayarlar-menu'
import { AyarlarOzelAlanlar } from './routes/ayarlar-ozel-alanlar'
import { Dernekler } from './routes/dernekler'
import { Guvenlik } from './routes/guvenlik'
import { Denetim } from './routes/denetim'
import { Destek } from './routes/destek'
import { Isler } from './routes/isler'
import { Kullanicilar } from './routes/kullanicilar'
import { Kurullar } from './routes/kurullar'
import { Ozet } from './routes/ozet'
import { Roller } from './routes/roller'
import { OdemeAyarlari } from './routes/odeme-ayarlari'
import { Uyeler } from './routes/uyeler'
import { WebSitesi } from './routes/web-sitesi'
import { WebSitesiDuzenleyici } from './routes/web-sitesi-duzenleyici'
import { Yakinda } from './routes/yakinda'

const rootRoute = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})

const routes = [
  createRoute({ getParentRoute: () => rootRoute, path: '/', component: Ozet }),
  createRoute({ getParentRoute: () => rootRoute, path: '/uyeler', component: Uyeler }),
  createRoute({ getParentRoute: () => rootRoute, path: '/aidat', component: Aidat }),
  createRoute({ getParentRoute: () => rootRoute, path: '/kurullar', component: Kurullar }),
  createRoute({ getParentRoute: () => rootRoute, path: '/web-sitesi', component: WebSitesi }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/web-sitesi/duzenleyici',
    component: WebSitesiDuzenleyici,
    // Hangi sayfanın düzenlendiği adreste: sekme yenilendiğinde ya da bağlantı
    // paylaşıldığında aynı sayfa açılsın.
    validateSearch: (arama: Record<string, unknown>) => ({
      sayfa: typeof arama.sayfa === 'string' ? arama.sayfa : undefined,
    }),
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/odeme-ayarlari',
    component: OdemeAyarlari,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/destek', component: Destek }),
  createRoute({ getParentRoute: () => rootRoute, path: '/denetim', component: Denetim }),
  createRoute({ getParentRoute: () => rootRoute, path: '/dernekler', component: Dernekler }),
  createRoute({ getParentRoute: () => rootRoute, path: '/isler', component: Isler }),
  createRoute({ getParentRoute: () => rootRoute, path: '/guvenlik', component: Guvenlik }),
  createRoute({ getParentRoute: () => rootRoute, path: '/ayarlar', component: Ayarlar }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/ayarlar/dernek',
    component: AyarlarDernek,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/ayarlar/menu', component: AyarlarMenu }),
  createRoute({ getParentRoute: () => rootRoute, path: '/ayarlar/roller', component: Roller }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/ayarlar/kullanicilar',
    component: Kullanicilar,
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/ayarlar/ozel-alanlar',
    component: AyarlarOzelAlanlar,
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/ayarlar/abonelik',
    component: AyarlarAbonelik,
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/ayarlar/alan-adlari',
    component: AyarlarAlanAdlari,
  }),
]

export const router = createRouter({
  routeTree: rootRoute.addChildren(routes),
  /**
   * Menü SUNUCUDAN geliyor (YES-122) ve katalog, ekranı henüz yazılmamış
   * modülleri de içeriyor. Burada tek tek yer tutucu rota tanımlamak yerine
   * "bulunamadı" ekranını anlamlı hâle getiriyoruz: katalog büyüdükçe bu
   * dosyayı güncellemek gerekmiyor — YES-122'nin "yeni modül kendiliğinden
   * görünsün" özelliği panelde de bozulmamış oluyor.
   */
  defaultNotFoundComponent: Yakinda,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
